import { jsx as _jsx } from "react/jsx-runtime";
import { createFileRoute, getRouteApi, } from '@tanstack/react-router';
import { useNavigate, } from '@tanstack/react-router';
import {} from '@tymia/main-api';
import { slugify, } from '@tymia/shared';
import { useLayoutEffect, } from 'react';
import { TherapistProfile, } from '../../../pages/user/TherapistProfile.js';
import { useTranslation, } from '../../../useTranslation.js';
export function getProfileSlug(tRoot, therapist) {
    const jobTitle = tRoot.user.jobTitle(therapist);
    const name = tRoot.user.name(therapist);
    return slugify([
        jobTitle,
        name,
    ].join('-'));
}
const ProfileDataRoute = getRouteApi('/profile/$customerId/$userId');
export const Route = createFileRoute('/profile/$customerId/$userId/$')({
    component: TherapistProfileWrapper,
});
function TherapistProfileWrapper() {
    const response = ProfileDataRoute.useLoaderData();
    const params = Route.useParams();
    const navigate = useNavigate();
    const tRoot = useTranslation();
    useLayoutEffect(() => {
        if (response.status !== 'ok') {
            return;
        }
        const profileSlug = getProfileSlug(tRoot, response.user);
        if (params._splat === profileSlug) {
            return;
        }
        void navigate({
            to: '/profile/$customerId/$userId/$',
            params: {
                customerId: params.customerId,
                userId: params.userId,
                _splat: profileSlug,
            },
            replace: true,
            resetScroll: false,
        });
    }, [
        response,
        params.customerId,
        params.userId,
        params._splat,
        navigate,
    ]);
    return _jsx(TherapistProfile, { response: response });
}
//# sourceMappingURL=$customerId.$userId.$.js.map